export const IncidentLabelNames = {
    resolvedString: 'Resolved'
}

export const StatusLabelNames = {
    good: 'Good',
    information: 'Information',
    warning: 'Warning',
    critical: 'Critical'
}